module.exports = __webpack_public_path__ + "img/network.73a218a1.png";